(() => {
  let hasRun = false;

  async function removeCartasFromCart() {
    if (hasRun) return;
    hasRun = true;

    try {
      const cartResponse = await fetch('/cart.js', {
        headers: { Accept: 'application/json' }
      });

      if (!cartResponse.ok) return;

      const cart = await cartResponse.json();

      if (!cart.items?.length) return;

      const updates = {};

      cart.items.forEach((item) => {
        if (item.properties && item.properties._cartas_checkout === '1') {
          updates[item.key] = 0;
        }
      });

      if (!Object.keys(updates).length) return;

      const updateResponse = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ updates })
      });

      if (!updateResponse.ok) return;

      document.documentElement.dispatchEvent(
        new CustomEvent('starina:cartas-removed-from-cart')
      );
    } catch (error) {
      console.warn('[Stariná Cartas] Não foi possível limpar o item Cartas do carrinho.', error);
    }
  }

  document.addEventListener('DOMContentLoaded', removeCartasFromCart);
  window.addEventListener('pageshow', removeCartasFromCart);
})();